import {
  AppBar, IconButton as MUIIconButton, Toolbar as MUIToolbar,
} from '@mui/material';
import styled from 'styled-components';

const Toolbar = styled(MUIToolbar)`
  && {
    height: ${({ theme }) => theme.shape.appbarHeight}px;
    min-height: ${({ theme }) => theme.shape.appbarHeight}px;
  }
`;

const StyledAppBar = styled(AppBar)`
  && {
    background: none;
    z-index: ${({ theme }) => theme.zIndex.drawer + 1};
    box-shadow:none;
    pointer-events: none;
  }
`;

const IconButton = styled(MUIIconButton)`
  && {
    pointer-events: all;
    color: ${({ theme }) => theme.palette.gray.main};
    &:hover {
      background-color: rgba(0, 0, 0, 0.04);
    }
  }
`;

interface ToolContainerProps {
  $showBackground: boolean;
}

const ToolContainer = styled.div<ToolContainerProps>`
  display: flex;
  align-items: center;
  margin-left: -${({ theme }) => theme.spacing(2)};
  padding-left: ${({ theme }) => theme.spacing(2)};
  padding-right: ${({ theme }) => theme.spacing(2)};
  border-radius: ${({ theme }) => 3 * theme.shape.borderRadius}px;
`;

export { Toolbar,
  StyledAppBar,
  ToolContainer,
  IconButton };
